import PropTypes from 'prop-types';

const IconServiceTaking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
    height="24"
    width="24"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path
      fill={props.color ? props.color : '#000000'}
      d="M22,5.7l-4.6-3.9l-1.3,1.5l4.6,3.9L22,5.7z M7.9,3.4L6.6,1.9L2,5.7l1.3,1.5C3.3,7.2,7.9,3.4,7.9,3.4z M12,4c-5,0-9,4-9,9
	s4,9,9,9c5,0,9-4,9-9S17,4,12,4z M12,20c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S15.9,20,12,20z"
    />
    <path fill={props.color ? props.color : '#000000'} d="M10.3,17V9l5,4L10.3,17z" />
  </svg>
);

IconServiceTaking.propTypes = {
  color: PropTypes.string
};

export default IconServiceTaking;
